import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type ClientStatus,
  patchClientsClientIDStatus,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { CLIENTS_QUERY_KEYS } from "../Queries/queryKeys";

interface UpdateClientStatusParams {
  clientID: string;
  status: ClientStatus;
}

export function useUpdateClientStatusMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ clientID, status }: UpdateClientStatusParams) =>
      patchClientsClientIDStatus({ status }, clientID),
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { clientID }) => {
      queryClient.invalidateQueries({ queryKey: CLIENTS_QUERY_KEYS.all });
      queryClient.invalidateQueries({
        queryKey: CLIENTS_QUERY_KEYS.detail(clientID),
      });
    },
  });
}
